'use client';

import { ArrowLeft, LockKeyhole, Sparkles } from 'lucide-react';

import {
  FEATURE_CATALOG,
  featureLabel,
  type Entitlements,
} from '@/lib/entitlements';

export function FeatureLocked({
  feature,
  entitlements,
  onBack,
}: {
  feature: string;
  entitlements: Entitlements | null;
  onBack: () => void;
}) {
  const catalog = entitlements?.catalog ?? FEATURE_CATALOG;
  const meta = catalog.find((entry) => entry.key === feature);
  const label = featureLabel(feature, catalog);
  const planName = entitlements?.plan.name ?? 'current';

  return (
    <div className="mx-auto max-w-2xl rounded-3xl border border-line bg-card p-6 text-center sm:p-10">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand/15 text-brand">
        <LockKeyhole className="h-6 w-6" />
      </span>
      <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-muted">Not included in your plan</p>
      <h2 className="mt-2 text-xl font-black tracking-tight text-ink sm:text-2xl">{label}</h2>
      <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-muted">
        {meta?.description ?? 'This module is part of a higher subscription tier.'}
        {' '}Your agency is on the <span className="font-semibold text-ink">{planName}</span> plan.
      </p>

      <div className="mx-auto mt-6 max-w-md rounded-2xl border border-line bg-shell p-4 text-left">
        <div className="flex items-center gap-2 text-xs font-semibold text-ink">
          <Sparkles className="h-4 w-4 text-brand" />
          Can be enabled without changing your plan
        </div>
        <p className="mt-1.5 text-xs leading-relaxed text-muted">
          Ask your platform administrator to grant <span className="font-semibold text-ink">{label}</span> to this agency.
          Extra access is applied on top of the subscription and is audited.
        </p>
      </div>

      <button
        type="button"
        onClick={onBack}
        className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand px-4 py-2 text-xs font-semibold text-slate-950"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to dashboard
      </button>
    </div>
  );
}
